import { httpClient } from '@texas/api/httpClient/httpClient';

export interface HandlingFeeItem {
  id: number;
  name: string;
  value: number;
  organizationId: number;
  displayOrder: number;
  archived: boolean;
}

export interface CreateHandlingFeeRequest {
  name: string;
  value: number;
  displayOrder: number;
}

export interface UpdateHandlingFeeRequest extends CreateHandlingFeeRequest {
  archived: boolean;
}

export const handlingFeesApi = {
  getAll: () => httpClient.get<HandlingFeeItem[]>('handlingfees/all'),
  createHandlingFee: (
    organizationId: number,
    request: CreateHandlingFeeRequest,
  ) =>
    httpClient.post<HandlingFeeItem>(
      `organizations/${organizationId}/handlingfees`,
      {
        data: request,
      },
    ),
  update: (id: number, request: UpdateHandlingFeeRequest) =>
    httpClient.put<HandlingFeeItem>(`handlingfees/${id}`, { data: request }),
};
